<template>
  <div class="transition">
    <BasicText size="h5">Pour quel type de contrat ou d’avenant ?</BasicText>
    <div
      class="transition-items"
      v-for="item in typesContratItems"
      :key="item.code"
    >
      <BasicCheckbox
        :label="item.intitule"
        :model-value="estRadionOn(item.code)"
        @update:model-value="updateOut(item.code)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onBeforeMount, ref } from 'vue'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { TypeContratAvenant as TypeContratAvenantCAPP } from '@/features/domaine/types/opco/Demande/CAPP'
  import { TypeContratAvenant as TypeContratAvenantCPRO } from '@/features/domaine/types/opco/Demande/CPRO'
  import type { HabilitationDispositifDTO } from '@/features/api/extranet/dto/Demande/shared'
  import type { LovDTO } from '@/features/api/extranet/dto/Lov'
  import { demandeService } from '@/features/services/demande'
  import type { LovCappDTO } from '@/features/api/extranet/dto/Demande/CAPP'
  import type { LovCproDTO } from '@/features/api/extranet/dto/Demande/CPRO'

  const props = defineProps<CarteProps<HabilitationDispositifDTO, TypeContratAvenantCAPP | TypeContratAvenantCPRO>>()
  const emits = defineEmits<CarteEvents<TypeContratAvenantCAPP | TypeContratAvenantCPRO>>()

  const typesContratItems = ref<LovDTO<string>>()

  onBeforeMount(async () => {
    const lov = (await demandeService.loadLovDispositif(props.in.code)) as LovCappDTO | LovCproDTO
    typesContratItems.value = lov.TypeContratAvenant
  })

  const estRadionOn = (typeContrat: string) => {
    return props.out === typeContrat
  }

  const updateOut = (typeContrat: string) => {
    emits('outChanged', true, typeContrat as TypeContratAvenantCAPP | TypeContratAvenantCPRO)
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
  .transition {
    gap: 6px;
    & > .text {
      margin-bottom: 20px;
    }
  }
</style>

